<div
  #editor
  data-cy="smart-search-editor"
  class="prompt-editor"
  [attr.contenteditable]="isEditable()"
  (input)="onInput($event); promptChange.emit(serialize())"
  (copy)="onCopy($event)"
  (cut)="onCut($event)"
  (paste)="onPaste($event)"
  [attr.placeholder]="'search.smart-search-panel.custom-prompt-placeholder' | translate"
  (blur)="promptChange.emit(serialize())"
></div>

@if (showAvailableTags()) {
  @let tags = availableTags();
  @if (tags.length && hasPromptContent()) {
    <div class="tags-bank">
      <div class="tags-bank-label">
        {{
          (tags.length > 1 ? 'search.smart-search-prompt.available-tags-plural' : 'search.smart-search-prompt.available-tags') | translate
        }}
      </div>
      @for (tagRef of tags; track tagRef[0]) {
        @let config = tagRef[1];
        <app-smart-search-tag
          [icon]="config.icon"
          [content]="config.content ? (config.placeholder ?? '' | translate) : usePreviewTags() ? config.placeholder : undefined"
          [display]="usePreviewTags() ? config.placeholder : undefined"
          [placeholder]="config.placeholder"
          [inputPlaceholder]="config.inputPlaceholder"
          [removable]="false"
          [editable]="false"
          [displayTooltip]="false"
          (mousedown)="$event.preventDefault(); $event.stopPropagation(); addTag(tagRef[0])"
          [ngbTooltip]="'search.smart-search-prompt.add-tag' | translate"
          tooltipClass="simple-tooltip"
          class="available-tag"
          placement="top auto"
        />
      }
    </div>
  }
  @if (allowCopy() || allowSave() || showRelaunchButton()) {
    <div class="editor-footer">
      @if (allowSave() && editor.innerText.trim().length) {
        <ex-button class="prompt-button" variant="ghost" icon="floppy-disk-back-fill" (click)="saveNewPrompt()">
          {{ 'common.save' | translate }}
        </ex-button>
      }
      @if (allowCopy() && editor.innerText.trim().length) {
        <ex-button
          class="prompt-button"
          variant="ghost"
          icon="copy-fill"
          (click)="copyPrompt()"
          #copyTooltip="ngbTooltip"
          [ngbTooltip]="tooltipCopy"
          placement="top auto"
          tooltipClass="simple-tooltip"
          triggers=""
        >
          {{ 'common.copy' | translate }}
        </ex-button>
      }
      @if (showRelaunchButton()) {
        <ex-button
          class="ms-auto"
          type="primary"
          variant="raised"
          icon="rocket-launch-fill"
          (click)="onRelaunchAnalysis()"
          [disabled]="!canTriggerSmartSearch()"
          [ngbTooltip]="getTooltipMessage() | translate"
          tooltipClass="simple-tooltip max-m"
          container="body"
          placement="top"
          triggers="hover focus"
          [openDelay]="0"
          [closeDelay]="0"
          [disableTooltip]="canTriggerSmartSearch()"
        >
          {{ 'search.smart-search-result.relaunch-analysis' | translate }}
        </ex-button>
      }
    </div>
  }
}

<ng-template #tooltipCopy>
  <span>{{ 'search.smart-search-panel.copied' | translate }}</span>
</ng-template>
